import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import Card from './Card';
import DataAid from '../../common/constants/data-aids';
import useRssFeed from '../../common/hooks/useRssFeed';
import ViewState from '../../common/components/ViewState';
import { SUCCESS } from '../../common/constants/viewStates';
import Field from '../../common/constants/editable-field-tags';
import { trimText } from '../../common/util';

const styles = {
  textAlign: 'center',
  infoContainer: {
    textAlign: 'center',
    ['@md']: {
      textAlign: 'left'
    }
  },
  image: {
    width: '100%',
    maxWidth: '280px',
    marginBottom: '20px'
  },
  about: {
    marginBottom: 'small'
  },
  toggler: {
    fontWeight: '600',
    cursor: 'pointer',
    textAlign: 'left'
  },
  description: {
    textAlign: 'left'
  }
};

const CHAR_LIMIT = 255;

function Layout2(props) {
  const {
    rssFeedUrl,
    env,
    staticContent,
    locale,
    renderMode,
    limit,
    isPrimaryLight,
    businessName,
    viewDevice
  } = props;
  const { viewState, podcast } = useRssFeed({
    env,
    rssFeedUrl,
    renderMode,
    limit,
    businessName,
    staticContent
  });
  const [playerIndex, setPlayerIndex] = useState(null);
  const [showFullDescription, setShowFullDescription] = useState(false);

  const { link, title, image, description } = podcast;
  const hasToggle = description?.long?.length > CHAR_LIMIT;
  const ellipsis = hasToggle ? '...' : '';
  const isMobile = viewDevice?.includes('MOBILE');

  const Grid = UX2.Component.Grid;
  const Cell = Grid.Cell;
  const getTCCLString = UX2.utils.TCCLUtils.getTCCLString;

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  return viewState === SUCCESS ? (
    <Grid
      gutter
      bottom={ isMobile }
      data-aid={ DataAid.PODCAST_CARDGROUP_RENDERED }
      data-route={ Field.CONTENT }
    >
      <Cell xs={ 12 } md={ 3 } style={ styles.infoContainer } data-route='podcastUrl'>
        { image && (
          <UX2.Element.Image
            src={ image }
            style={ styles.image }
            data-aid={ DataAid.PODCAST_IMAGE_RENDERED }
          />
        ) }
        { description?.long && (
          <>
            <UX2.Element.SubTagline style={ styles.about } data-aid={ DataAid.PODCAST_ABOUT_RENDERED }>
              { staticContent.aboutPodcast }
            </UX2.Element.SubTagline>
            <UX2.Element.Text
              data-aid={ DataAid.PODCAST_DESCRIPTION_RENDERED }
              style={ styles.description }
              dangerouslySetInnerHTML={{
                __html: showFullDescription
                  ? description.long
                  : `${trimText(description.long, CHAR_LIMIT)}${ellipsis}`
              }}
            />
            { hasToggle && (
              <UX2.Element.Text
                onClick={ toggleDescription }
                style={ styles.toggler }
                data-aid={ DataAid.PODCAST_TOGGLE_ABOUT_RENDERED }
                data-tccl={ getTCCLString({
                  eid: showFullDescription
                    ? 'ux2.podcast.hide_about.click'
                    : 'ux2.podcast.show_about.click',
                  type: 'click'
                }) }
              >
                { `${showFullDescription ? staticContent.readLess : staticContent.readMore}` }
              </UX2.Element.Text>
            ) }
          </>
        ) }
      </Cell>
      <Cell xs={ 12 } md={ 9 }>
        { podcast.episodes.slice(0, limit).map((episode, index) => (
          <Card
            id={ `card${index}` }
            episode={ episode }
            link={ link }
            podcastTitle={ title }
            key={ episode.guid }
            index={ index }
            isPlaying={ playerIndex === index }
            setPlayerIndex={ setPlayerIndex }
            staticContent={ staticContent }
            locale={ locale }
            isPrimaryLight={ isPrimaryLight }
          />
        )) }
      </Cell>
    </Grid>
  ) : (
    <ViewState viewState={ viewState } staticContent={ staticContent } renderMode={ renderMode } />
  );
}

Layout2.propTypes = {
  episodes: PropTypes.any,
  link: PropTypes.string,
  title: PropTypes.string,
  about: PropTypes.string,
  image: PropTypes.string,
  limit: PropTypes.string,
  description: PropTypes.object,
  staticContent: PropTypes.object,
  locale: PropTypes.string,
  rssFeedUrl: PropTypes.string,
  env: PropTypes.string,
  renderMode: PropTypes.string,
  businessName: PropTypes.string,
  viewDevice: PropTypes.string,
  isPrimaryLight: PropTypes.bool
};

export default Layout2;
